import { HttpResponseError } from '@vista-digital/http-client';
export const getJourneyPollingPredicate = (retryOnStatusCodes) => {
    return async (response) => {
        if (!response.ok) {
            if (retryOnStatusCodes.indexOf(response.status) !== -1) {
                return false;
            }
            const error = new HttpResponseError(response);
            if (error.isTransient) {
                // Return false to allow polling to continue if the error is retryable.
                return false;
            }
            throw error;
        }
        return response.status === 200;
    };
};
//# sourceMappingURL=journey-polling-predicate.js.map